import { Badge, BadgeProps, styled } from '@mui/material';
import React from 'react';

interface DotBadgeStyleProps {
  dotStyle?: React.CSSProperties;
  badgeStyle?: React.CSSProperties;
}

export interface DotBadgeProps extends BadgeProps, DotBadgeStyleProps {}

const StyledBadge = styled(Badge)(({ dotStyle, badgeStyle }: DotBadgeStyleProps) => ({
  '& .MuiBadge-dot': dotStyle,
  '& .MuiBadge-badge': badgeStyle,
}));

export const DotBadge = (props: DotBadgeProps) => (
  <StyledBadge color="error" variant="dot" overlap="circular" {...props} />
);
